<template>
  <loader v-if="loading" />
</template>
<script>
import Loader from '../../components/Loader.vue'
import { convertObjToString } from '../../lib/helpers'
import { HTTPAUTH } from '../../lib/httplib'
export default {
  components: { Loader },
  data () {
    return {
      data: {},
      loading: false
    }
  },
  computed: {
    domain () {
      return this.$route.params.domain
    },
    sub () {
      return this.$route.params.sub
    },
    query () {
      return this.$route.query
    }
  },
  created () {
    this.download()
  },
  methods: {
    download () {
      this.loading = true
      HTTPAUTH.get(`/api/v1/exports/${this.domain}/${this.sub}?${convertObjToString(this.query)}`).then(res => {
        console.log(res.data, "ini test")
        this.data = res.data
        window.location.href = `${process.env.VUE_APP_API_HOST}${res.data.data}`
        this.loading = false
        setTimeout(() => {
          window.close()
        }, 1000)
      }).catch(() => {
        this.loading = false
      })
    }
  }
}
</script>